const heroes = [
  'Deadpool',
  'Spider-Man',
  'Iron Man',
  'Captain America',
  'Black Widow',
  'Hawkeye',
  'Doctor Strange',
  'Black Panther',
  'Scarlet Witch',
  'Captain',
  'Falcon',
  'Winter',
  'Shang-Chi',
  'Daredevil',
  'Jessica Jones',
  'Luke Cage',
  'Iron Fist',  
  'Wolverine',
  'Storm',
  'Jean Grey',  
  'Rogue',
  'Beast',
  'Gambit',
  'Professor X',
  'Magneto',
  'Silver Surfer',
  'Superman',
  'Batman',
  'Wonder Woman',
  'The Flash',
  'Aquaman',
  'Green Lantern',
  'Cyborg',
  'Martian Manhunter',
  'Green Arrow',
  'Black Canary',
  'Shazam',
  'Supergirl',
  'Batgirl',
  'Nightwing',
  'Robin',
  'Zatanna',
  'Blue Beetle',
  'Hawkman',
  'Hawkgirl',
  'Constantine',
  'Atom',
  'Raven',
  'Starfire',
  'Beast Boy',
  'Red Hood',
];

export const oktaAuthConfig = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '',
  issuer: process.env.REACT_APP_OKTA_BASE_URL || '',
  redirectUri: process.env.REACT_APP_OKTA_REDIRECTURI || '',
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
};

export const novaDreamMapConfig = {
  token: process.env.REACT_APP_API_TOKEN,
  urlBase: process.env.REACT_APP_API_URL,
  Name: 'Nova Dream',
  Version: 'Version 1.2.5 ' + heroes[0] + ' - 05/08/2025',
  urlAmplify: process.env.REACT_APP_URL_AMPLYFY,
};



// git switch main
// git status
// git pull --progress -v --no-rebase "origin"
// git switch preprod
// git status
// git pull --progress -v --no-rebase "origin"
// git merge main
// git push --progress "origin" preprod:preprod



